import { render, staticRenderFns } from "./IncomeStatementList.vue?vue&type=template&id=6887440f&scoped=true"
import script from "./IncomeStatementList.vue?vue&type=script&lang=js"
export * from "./IncomeStatementList.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatementList.vue?vue&type=style&index=0&id=6887440f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887440f",
  null
  
)

export default component.exports